import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { WinLossPattern } from '../../utils/salesWinLossAnalytics';

interface Props {
  pattern: WinLossPattern;
  type: 'win' | 'loss';
  crmWinRate?: number;
  weight?: number;
}

const ClosingFactorCard: React.FC<Props> = ({ pattern, type, crmWinRate, weight }) => {
  const [open, setOpen] = useState(false);
  const hasBody = Boolean(pattern.description) || Boolean(pattern.evidence?.length);
  const hasExtra = crmWinRate !== undefined || Boolean(pattern.confidence);
  const expandable = hasBody || hasExtra;

  return (
    <div className={`sa-pattern-row sa-pattern-row--${type}${open ? ' is-open' : ''}`}>
      <button
        type="button"
        className="sa-pattern-row-btn"
        onClick={() => expandable && setOpen(o => !o)}
        aria-expanded={expandable ? open : undefined}
        disabled={!expandable}
      >
        <span className="sa-pattern-row-title">{pattern.title}</span>
        <span className="sa-pattern-row-meta">
          {weight !== undefined && (
            <span className="sa-pattern-row-weight">{Math.round(weight * 100)}%</span>
          )}
          {expandable && (open ? <ChevronDown size={14} /> : <ChevronRight size={14} />)}
        </span>
      </button>
      {open && (
        <div className="sa-pattern-row-body">
          {pattern.description && <p className="sa-pattern-row-desc">{pattern.description}</p>}
          {pattern.evidence?.length ? (
            <ul className="sa-pattern-row-evidence">
              {pattern.evidence.map((e, i) => (
                <li key={i}>{e}</li>
              ))}
            </ul>
          ) : null}
          {crmWinRate !== undefined && (
            <p className="sa-muted">CRM source win rate: {crmWinRate.toFixed(0)}%</p>
          )}
          {pattern.confidence && <p className="sa-muted">Confidence: {pattern.confidence}</p>}
        </div>
      )}
    </div>
  );
};

export default ClosingFactorCard;
